import { render, staticRenderFns } from "./ReviewPages.vue?vue&type=template&id=f2506de0&"
import script from "./ReviewPages.vue?vue&type=script&lang=js&"
export * from "./ReviewPages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports